import { useState } from 'react';
import { useLocation } from 'react-router';

import { useLocalStorage } from './useLocalStorage';
import { useBreakpoint } from './useMeasure';

/** Returns the collapsed state of the nav and the open state of the phone drawer. */
export function useShellChrome(storageKey = 'edify_sidebar_collapsed') {
  const [collapsed, setCollapsed] = useLocalStorage(storageKey, false);
  const { pathname } = useLocation();
  const [drawerPath, setDrawerPath] = useState<string | null>(null);
  const isWide = useBreakpoint('lg');

  // Closes the drawer when the page changes.
  if (drawerPath !== null && drawerPath !== pathname) setDrawerPath(null);

  return {
    collapsed: isWide && collapsed,
    toggleCollapsed: () => setCollapsed((value) => !value),
    drawerOpen: !isWide && drawerPath === pathname,
    openDrawer: () => setDrawerPath(pathname),
    closeDrawer: () => setDrawerPath(null),
  };
}
